import { Box, IconButton, Tooltip, Divider, FormControl, Select, MenuItem, InputLabel } from '@mui/material'
import FormatBoldIcon from '@mui/icons-material/FormatBold'
import FormatItalicIcon from '@mui/icons-material/FormatItalic'
import TitleIcon from '@mui/icons-material/Title'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered'
import FormatQuoteIcon from '@mui/icons-material/FormatQuote'
import LinkIcon from '@mui/icons-material/Link'
import ImageIcon from '@mui/icons-material/Image'
import UndoIcon from '@mui/icons-material/Undo'
import RedoIcon from '@mui/icons-material/Redo'

export default function ToolBarEditor({ editor }) {
    if (!editor) return null

    const addLink = () => {
        const url = prompt('URL')
        if (url) {
            editor.chain().focus().setLink({ href: url }).run()
        }
    }

    const setFontSize = (size) => {
        editor.chain().focus().setFontSize(size).run()
    }


    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap',
                p: 1,
                border: '1px solid #ddd',
                borderRadius: 2,
                mb: 2,
                background: '#fafafa'
            }}
        >
            <Tooltip>
                <FormControl size="small" sx={{ minWidth: 100 }}>
                    <InputLabel>Tamaño</InputLabel>

                    <Select
                        label="Tamaño"
                        defaultValue="16px"
                        onChange={(e) => setFontSize(e.target.value)}
                    >
                        <MenuItem value="12px">12</MenuItem>
                        <MenuItem value="14px">14</MenuItem>
                        <MenuItem value="16px">16</MenuItem>
                        <MenuItem value="18px">18</MenuItem>
                        <MenuItem value="20px">20</MenuItem>
                        <MenuItem value="24px">24</MenuItem>
                        <MenuItem value="32px">32</MenuItem>
                    </Select>
                </FormControl>
            </Tooltip>

            <Tooltip title="Bold">
                <IconButton onClick={() => editor.chain().focus().toggleBold().run()}>
                    <FormatBoldIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Italic">
                <IconButton onClick={() => editor.chain().focus().toggleItalic().run()}>
                    <FormatItalicIcon />
                </IconButton>
            </Tooltip>

            <Divider orientation="vertical" flexItem />

            <Tooltip title="Heading">
                <IconButton onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>
                    <TitleIcon />
                </IconButton>
            </Tooltip>

            <Divider orientation="vertical" flexItem />

            <Tooltip title="Lista">
                <IconButton onClick={() => editor.chain().focus().toggleBulletList().run()}>
                    <FormatListBulletedIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Numerada">
                <IconButton onClick={() => editor.chain().focus().toggleOrderedList().run()}>
                    <FormatListNumberedIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Quote">
                <IconButton onClick={() => editor.chain().focus().toggleBlockquote().run()}>
                    <FormatQuoteIcon />
                </IconButton>
            </Tooltip>

            <Divider orientation="vertical" flexItem />

            <Tooltip title="Link">
                <IconButton onClick={addLink}>
                    <LinkIcon />
                </IconButton>
            </Tooltip>

            <Divider orientation="vertical" flexItem />

            <Tooltip title="Undo">
                <IconButton onClick={() => editor.chain().focus().undo().run()}>
                    <UndoIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Redo">
                <IconButton onClick={() => editor.chain().focus().redo().run()}>
                    <RedoIcon />
                </IconButton>
            </Tooltip>
        </Box>
    )
}